exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".finance-bill-cost-page .back-line[data-v-524934e8]{line-height:32px;margin-bottom:10px}.finance-bill-cost-page .back-line i[data-v-524934e8]{font-size:18px;margin-right:8px}.finance-bill-cost-page .back-line i[data-v-524934e8]:hover{cursor:pointer}.pagination-stat[data-v-524934e8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pagination-stat .stat[data-v-524934e8]{font-size:16px}\n", ""]);

// exports
